import { render } from "./OrderCart.vue?vue&type=template&id=5ec489bc&scoped=true"
import script from "./OrderCart.vue?vue&type=script&lang=js"
export * from "./OrderCart.vue?vue&type=script&lang=js"

import "./OrderCart.vue?vue&type=style&index=0&id=5ec489bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec489bc"]])

export default __exports__